// extracted by mini-css-extract-plugin
export default {"formContainer":"PasswordReset_formContainer__Hh3NU","form":"PasswordReset_form__cUIpB","label":"PasswordReset_label__PzsYb","required":"PasswordReset_required__lodgv"};